<template>
  <div class="container">

    <div class="task-wrapper" style="overflow-y: auto;height: 600px;padding: 10px;">

      <div v-show="!isLoader" v-for="(task) in quickTaskList" :key="task.id" class="task-row">
        <v-row class="main-task">
          <v-col cols="6">
            <p
                :id="'tooltip-target-'+task.id"
                class="task-desc"
                :class="{'line-through': task.status === 1}"
            >
              {{ task.title.length > 70 ? `${task.title.substring(0, 40)}...` : task.title }}
            </p>
            <b-tooltip :target="'tooltip-target-'+task.id" triggers="hover" placement="bottom" custom-class="quickTooltip">
              {{ task.title }}
            </b-tooltip>
          </v-col>
          <v-col cols="6">
            <div class="date-button">
                <div class="task-date">
                 <div>
                   <img :src="calendarIcon">
                 </div>
                  <div class="date-content">
                    <p>{{task.due_date }} {{ task.time }}</p>
                  </div>
                </div>
                <div class="button-wrapper">
                  <button class="task-button" :class="{'completed': task.status === 1}" @click="markCompleted(task)">
                      <img v-if="task.status === 0" :src="unCheckIcon">
                      <img v-if="task.status === 1" :src="checkIcon">

                      {{ task.status === 0 ? "Mark Completed" : "Completed" }}
                  </button>
                </div>

            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="!quickTaskList.length"  class="task-row"  style="display: flex; justify-content: center">

          <p style="align-items: center">No Data Found</p>

      </div>
    </div>

  </div>
</template>

<script>

import Multiselect from "vue-multiselect";
import checkIcon from '@/assets/images/check.svg'
import unCheckIcon from '@/assets/images/uncheck.svg'
import calendarIcon from '@/assets/images/calendar.svg'
import moment from "moment/moment";


export default {
  components: {
    Multiselect
  },
  props: [
    "quickTaskList",
    "totalPages",
    "page",
    "flag",
    "total",
    "totalRows",
    "currentPage",
  ],
  data() {
    return {
      isLoader: true,
      selectTab: "",
      countUnchecked: 0,
      checkboxAll: true,
      checkIcon:checkIcon,
      unCheckIcon:unCheckIcon,
      calendarIcon:calendarIcon,

    };
  },
  computed: {
    moment() {
      return moment
    },
    currentPage: {
      get: function () {
        this.showstatus = false;
        this.selectTab = localStorage.getItem("tab");
        return this.page4;
      },
      set: function () {
      },
    },

    showskLoader: function () {
      this.isLoader = this.setskeletonLoader;
      return this.setskeletonLoader;
    }
  },

  mounted: function () {

    this.isLoader = this.setskeletonLoader;
  },
  watch: {
    showskLoader: function () {
      this.selectTab = localStorage.getItem("tab");
      this.isLoader = this.setskeletonLoader;
      return this.setskeletonLoader;
    },

  },


  methods: {
    setPage(page) {
      console.log("emit function child=>",page)
      this.$emit("setPageQuickTask",page);
    },

    async markCompleted(task) {
      const newStatus = task.status === 0 ? 1 : 0;
      task.status = newStatus;

      try {
        await this.$store.dispatch('quick_task/updateTaskStatus', {taskId: task.id, status: newStatus});
        var text = "Task Marked as Complete.";
        if(newStatus === 0)
        {
          var text ="Task Marked as Incomplete.";
        }
        this.$toast.success(text);
      } catch (error) {
        // Handle any errors if needed
      }
    }

  },

};
</script>

<style scoped>
.container {
  padding: 20px;
}

.btn-primary {
  background-color: #7366FF;
  color: white;
}

.btn-primary:disabled {
  cursor: not-allowed;
}

.strikethrough {
  text-decoration: line-through;
  color: gray;
}
.task-wrapper::-webkit-scrollbar {
  width: 4px;
}

.task-wrapper::-webkit-scrollbar-track {
  background: #fff;
  border-radius: 3px;
}

.task-wrapper::-webkit-scrollbar-thumb {
  background: #48a6a6;
  border-radius: 3px;
}
.task-wrapper .task-row{
  border: 1px solid #EAEBED;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.task-row .main-task{
  align-items: center;
  padding: 0px 12px;
}
.task-wrapper .date-button{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}
.task-wrapper .task-desc{
  font-size: 13px;
  font-weight: 500;
  line-height: 19.5px;
  text-align: left;
  color:#616975;
  margin: 0;
  width: fit-content;
}
.task-wrapper .task-date{
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: end;
  color: #3D4551;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  min-width: 150px;
}
.task-date .date-content{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 3px;
}
.date-content p{
  margin: 0;
}
.button-wrapper{
  display: flex;
  align-items: center;
  justify-content: end;
}
.task-button{
  background: #F8F8F8;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  text-align: left;
  color: #0C1726;
  padding: 6px 14px 6px 14px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-width: 150px;
}
.task-button.completed{
  background: #48A6A6;
  color: #FFFFFF;
}
.tooltip.b-tooltip{
  top: 0 !important;
}

.tooltip .tooltip-inner{
  max-width: 500px !important;
}
.line-through {
  text-decoration: line-through;
}
</style>
